import { apiClient } from '@v2/lib';
import type { BillingAuditEntry, BillingAuditPagedResult, BillingAuditQuery } from '@v2/types';

/**
 * Billing Metadata Audit Service
 *
 * Domain: Audit log for billing metadata PATCH operations
 * Base path: /v1/practicelocations/billing-audit
 *
 * Queries:
 *   - listBillingAudit(query) → GET /v1/practicelocations/billing-audit
 */

export const billingAuditService = {
  listBillingAudit: async (query: BillingAuditQuery): Promise<BillingAuditPagedResult> => {
    const params: Record<string, string | number> = {};
    if (query.practiceLocationId) params.practiceLocationId = query.practiceLocationId;
    if (query.practiceId) params.practiceId = query.practiceId;
    if (query.operatorAccountId) params.operatorAccountId = query.operatorAccountId;
    if (query.since) params.since = query.since;
    if (query.until) params.until = query.until;
    if (query.page != null) params.page = query.page;
    if (query.pageSize != null) params.pageSize = query.pageSize;

    const response = await apiClient().get<BillingAuditPagedResult>(
      'v1/practicelocations/billing-audit',
      { params },
    );
    return response.data;
  },
};

export type { BillingAuditEntry, BillingAuditPagedResult, BillingAuditQuery };
